var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPipe3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 338,
    height: 202,
    viewBox: "0 0 338 202",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_20)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 201.5H283.5C313.6 201.5 338 177.1 338 147L338 1.967e-06L293 0V147C293 152.247 288.747 156.5 283.5 156.5H0.5V201.5Z",
    fill: "#70A0D7",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.518 129L334.988 112.203H296.049L315.518 129Z",
    fill: "url(#paint0_linear_9_20)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.5 115.198L334.969 98.4005H296.03L315.5 115.198Z",
    fill: "url(#paint1_linear_9_20)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.481 101.396L334.951 84.5992H296.012L315.481 101.396Z",
    fill: "url(#paint2_linear_9_20)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9_20",
    x1: 315.518,
    y1: 129,
    x2: 315.518,
    y2: 106.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9_20",
    x1: 315.5,
    y1: 115.198,
    x2: 315.5,
    y2: 92.8014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9_20",
    x1: 315.481,
    y1: 101.396,
    x2: 315.481,
    y2: 79.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_20"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 338,
    height: 202,
    fill: "white",
    transform: "matrix(-1 0 0 1 338 0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipe3);
export default __webpack_public_path__ + "static/media/pipe-3.7d18e21bcf31d6b80d3486b0e7ca589a.svg";
export { ForwardRef as ReactComponent };